import { render, staticRenderFns } from "./genelamacli.vue?vue&type=template&id=48813fca"
import script from "./genelamacli.vue?vue&type=script&lang=js"
export * from "./genelamacli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports